import React, { FC } from 'react';

import classes from './BundleImage.scss';

type Props = {
    image: string;
    altText: string;
};

export const BundleImage: FC<Props> = ({ image, altText }) => (
    <div className={classes.image}>
        <img src={image} alt={altText} />
    </div>
);
